module.exports = __webpack_public_path__ + "static/devfestspgf19-bdced13228aa8dd24c2db718132973b2.jpg";